<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <input v-model="searchParams.recode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Số phòng</div>
                <div class="child-w-80">
                  <input v-model="searchParams.roomNum" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Lễ tân</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.accountId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in receptionistOptions"
                      :key="index"
                      :value="item.account.id"
                      :label="`(${item.account.username}) ${item.account.full_name}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.product') }}</div>
                <el-select
                  v-model="searchParams.productId"
                  collapse-tags
                  filterable
                  clearable
                  placeholder="Chọn sản phầm"
                >
                  <el-option
                    v-for="item in productOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số hóa đơn' }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.invoiceCode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    :disabled="disabledDate"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box daily-trans-report">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo mini bar</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="daily-trans__list">
            <el-collapse v-model="collapseNameList">
              <div
                v-for="dailyTrans in dailyTransDataList"
                :key="dailyTrans.id"
                class="daily-trans__item"
              >
                <el-collapse-item :name="dailyTrans.id">
                  <template slot="title">
                    <span class="daily-trans__item-header">
                      {{ 'Khách sạn:' }} {{ dailyTrans.hotel_name }}
                    </span>
                  </template>

                  <div class="grid-scroll" style="height: 400px">
                    <GridVx
                      ref="agGrid"
                      :columns="columns"
                      :rows="dailyTrans.rows"
                      :full-width-cell-renderer="fullWidthCellRenderer"
                      :default-col-def="defaultColDef"
                      dom-layout="scroll"
                      :is-row-selectable="isRowSelectable"
                      class="agGrid daily-trans-synthesis-grid"
                      :auto-size-cell="true"
                    />
                  </div>
                </el-collapse-item>
                <div class="daily-trans__item-footer">
                  <span>
                    {{ 'Tổng' }}: {{ $displayCurrency(dailyTrans.total) }}
                  </span>
                  <span style="padding-left: 20px">
                    {{ 'Số lượng' }}:
                    {{ $displayCurrency(dailyTrans.total_quantity) }}
                  </span>
                </div>
                <!-- <div class="daily-trans__item-footer">Tổng: 220000</div> -->
              </div>
            </el-collapse>
            <div class="daily-trans__item-footer">
              <span>
                {{ 'Tổng cộng' }} : {{ $displayCurrency(totalMoney) }}
              </span>
              <span style="padding-left: 20px">
                {{ 'Số lượng' }}:
                {{ $displayCurrency(totalQuantity) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã sản phẩm: Hiển thị mã sản phẩm</li>
            <li>Tên: Hiển thị tên mặt hàng</li>
            <li>Đơn giá: Hiển thị giá đơn vị của dịch vụ</li>
            <li>Số lượng: Hiển thị số lượng sản phẩm được sử dụng theo bill</li>
            <li>Thành tiền: Hiển thị thành tiền = giá đơn vị * số lượng</li>
            <li>Giảm giá: Hiển thị giảm giá dịch vụ theo giá tổng tiền</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'
import FullWidthCell from './components/FullWidthCellTransaction.vue'
import {
  getListMinibarReport,
  getListMinibarReportExcel,
  getReceptionestOptions,
  getProductMinibarOptions
} from '@/api/report_service/miniBarReport'
import { getAllHotel } from '@/api/hotel'
import { downFile } from '@/utils/file-handler'

export default {
  components: {
    CalendarRange,
    InfoBtn,
    // eslint-disable-next-line vue/no-unused-components
    FullWidthCell
  },
  data() {
    return {
      totalMoney: null,
      totalQuantity: null,
      disabledDate: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisible: false,
      hotelList: [],
      receptionistOptions: [],
      productOptions: [],
      searchParams: {
        hotelIds: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: '',
        code: 'MINIBAR',
        roomNum: null,
        accountId: null,
        productId: null,
        invoiceCode: null
      },
      dailyTransDataList: [],
      defaultSearchParams: {
        hotelIds: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: '',
        code: 'MINIBAR',
        roomNum: null,
        accountId: null,
        productId: null,
        invoiceCode: null
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      isRowSelectable: node => !node.data.isFullWidthRow,
      collapseNameList: [],
      columns: [
        {
          headerName: this.$t('grid.column.productCode'),
          field: 'product_code',
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: this.$t('grid.column.productName'),
          field: 'product_name',
          flex: 1,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.priceUnit'),
          field: 'unit',

          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          }
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.quantity'),
          field: 'quantity',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 80,
          maxWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.discount'),
          field: 'discount',
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.intoMoney'),
          field: 'price',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          }
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  computed: {
    recode() {
      return this.searchParams.recode
    }
  },
  watch: {
    recode: {
      handler(val) {
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },

  created() {
    this.getListHotel()
    this.getReceptionestList()
    this.fnGetProductOptions()
  },
  beforeMount() {
    this.fullWidthCellRenderer = 'FullWidthCell'
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getReceptionestList() {
      const data = await getReceptionestOptions()
      this.receptionistOptions = data.data || []
    },
    async fnGetProductOptions() {
      const data = await getProductMinibarOptions()
      this.productOptions = data.data || []
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    tranferRowData(dataList) {
      let transferedDataList = []
      dataList.forEach(dataItem => {
        // Get FLAT array
        const dataRows = dataItem.data.flatMap(item => {
          const dataItemTop = item.top
          const dataItemBot = item.bot

          const firstRow = {
            isFullWidthRow: true,
            billNumber: dataItemTop.invoice_num,
            billDate: dataItemTop.create_date,
            bookingCode: dataItemTop.recode,
            createdBy: dataItemTop.staff,
            roomNum: dataItemTop.room_num,
            totalDiscount: dataItemBot.total_discount,
            totalBill: dataItemBot.total_money
          }

          // const secondRow = {
          //   isFullWidthRow: true,
          //   totalBill: dataItemBot.total_money,
          //   totalDiscount: dataItemBot.total_discount,
          //   includeTaxFee: dataItemBot.include_tax_fee,
          //   billNum: dataItemTop.invoice_num,
          //   serviceFee: dataItemBot.fee,
          //   taxFee: dataItemBot.tax
          // }

          return [firstRow, ...item.product]
        })

        const transferedData = {
          hotel_id: dataItem.hotel_id,
          hotel_name: dataItem.hotel_name,
          total: dataItem.total,
          total_quantity: dataItem.total_quantity,
          rows: dataRows
        }

        this.totalAmount += dataItem.total

        transferedDataList.push(transferedData)

        // For Showing all item
        // this.collapseNameList.push(dataItem.hotel_id)
      })
      return transferedDataList
    },
    async attachData() {
      try {
        this.loading = true
        let data = await getListMinibarReport(this.searchParams)

        this.dailyTransDataList = this.tranferRowData(data.data)
        this.totalMoney = data.total
        this.totalQuantity = data.number
        this.loading = false
        // this.rows = data.data
      } catch {
      } finally {
        this.loading = false
      }
    },
    async downloadExcel() {
      try {
        this.loading = true
        let data = await getListMinibarReportExcel(this.searchParams)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(data, 'bao_cao_minibar_' + date + '.xlsx')

        this.loading = false
      } catch {
      } finally {
        this.loading = false
      }
    },

    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.daily-trans-report {
  --cell-border-color: rgba(189, 195, 199, 0.5);
  --ag-header-bg: #5f8b76;

  height: 100%;

  .daily-trans__list {
    display: flex;
    flex-direction: column;
    // gap: 20px;
    flex: 1;
    overflow-y: auto;

    .el-collapse {
      border: 0 !important;
    }
  }

  .daily-trans__item {
    .el-collapse-item__header {
      background-color: #357456;
      color: #fff !important;
      border-bottom: 1px solid var(--cell-border-color);
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    &-header {
      font-weight: 600;
      flex: 1;
      font-size: 14px;
      padding: 0 12px;
    }

    &-footer {
      height: 34px;
      line-height: 34px;
      padding: 0 12px;
      background-color: #e7f6e5 !important;
      border-bottom: 1px solid var(--cell-border);
      margin-bottom: 2px;
      font-weight: 500;
      font-size: 14px;
    }

    .grid-scroll {
      // height: 400px;
      // max-height: 400px;
    }

    .daily-trans-synthesis-grid.agGrid {
      .ag-header-viewport {
        background-color: var(--ag-header-bg) !important;
      }

      .header-row,
      .header-row:hover {
        background-color: var(--ag-header-bg) !important;
        color: white;
        font-weight: bold;
      }

      .ag-header-row-column {
        background-color: var(--ag-header-bg) !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.content-container .content-box .section-box.outline {
  height: auto !important;
}
</style>
